// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"313":"1c12261a","622":"847de69d"}[chunkId] + ".css";
};